<!-- 底部组件 -->
<template>
  <div>
    <div :class="'foot type' + type">
      <div class="top">
        <div :class="'left type' + $store.state.pageType">
          <div class="one" v-for="(item, index) in navs" v-if="$store.state.sizeType == 'pc' && item.children" :key="index">
            <p class="title" @click="goPage(item)">{{ item.name }}</p>
            <div class="lists">
              <p @click="goPage(item2, index2)" v-for="(item2, index2) in item.children" :key="index2">{{ item2.name }}</p>
            </div>
          </div>

          <div class="one">
            <p class="title">联系我们</p>
            <div class="line">
              <img v-if="type == 2" class="icon" src="../assets/home/customer-service-line (1)2.png">
              <img v-else class="icon" src="../assets/home/customer-service-line (1).png">
              <div>021-58768929</div>
            </div>
            <div class="line">
              <img v-if="type == 2" class="icon" src="../assets/home/mail-ai-line (2)2.png">
              <img v-else class="icon" src="../assets/home/mail-ai-line (2).png">
              <div>sales@corepilot-semi.com</div>
            </div>
            <div class="line">
              <div class="icon"></div>
              <div>contact@corepilot-semi.com</div>
            </div>
          </div>
          <div class="one">
            <p class="title">关注我们</p>
            <img class="erweima" src="../assets/home/erweima.png">
          </div>
        </div>
        <!-- <div class="logos" v-if="type == 2">
          <img class="logo1" src="../assets/home/wechat-fill (3).png">
          <img class="logo2" src="../assets/home/6kehul7hgry.png">
        </div>
        <div v-else>
          <img class="logo1" src="../assets/home/wechat-fill (2).png">
          <img class="logo2" src="../assets/home/dibuwithe.png">
        </div> -->
      </div>
      <div class="bottom">
        <span v-if="$store.state.sizeType == 'pc'">Copyright @上海启芯领航半导体有限公司 | 沪ICP备2025153123号 | 沪公网安备31010502007566号</span>
        <div v-else>
          <div>Copyright @上海启芯领航半导体有限公司</div>
          <div>沪ICP备2025153123号</div>
          <div>沪公网安备31010502007566号</div>
        </div>
        <span>
          <span class="button" @click="openModal(3)">法律声明</span> | 
          <span class="button" @click="openModal(4)">隐私政策</span>
        </span>
      </div>
    </div>
    <Modal
      v-model="open"
      :title="title"
      width="1200px"
      footer-hide>
      <div class="content">
        <div v-html="content"></div>
      </div>
  </Modal>
  </div>
  
</template>

<script>
export default {
  name: 'foot',
  inject: ['reload'],
  props: ["type"],
  data() {
    return {
      language: {},// 文案
      navs: [],
      navs1: [],
      navs2: [],
      open: false,
      title: '',
      content: '',
    };
  },
  methods: {
    // 进入采购页面
    goCaigou: function () {
      window.open("http://b2b.rsm.com.cn:86/HomeSite/Site/Index");
    },
    // 进入其他页面
    goPage: function (item, index) {
      this.$router.push({ path: item.path, query: item.other ? { ...item.other } : {} });
    },
    openModal(type) {
      this.$config('/open/api/about/list', {type}).then(res => {
        this.content = res.data[0].content;
        if(type == 3){
          this.title = '法律声明'
        } else {
          this.title = '隐私政策'
        }
        this.open = true
      })
    },
  },
  mounted() {
    this.navs = this.$language[this.$store.state.pageType].foot.navs;
    this.language = this.$language[this.$store.state.pageType].foot;
  }
};
</script>

<style scoped lang='scss'>
.foot {
  // height: 376px;
  padding: 0 calc(50% - 600px);
  background: #000024;
  color: #6B7285;
  font-size: 12px;
  font-weight: 300;
  // text-align: center;

  &.type2 {
    background: #F1F0F5;

    .title {
      color: #000 !important;
    }

    .line,
    p,
    .bottom {
      color: #333 !important;
    }
  }

  .top {
    // height: 335px;
    border-bottom: 1px solid #19194C;
    ;
    // display: flex;
    // justify-content: space-between;
    padding-top: 55px;
    padding-bottom: 0.15rem;

    .left {
      width: 100%;
      display: flex;
      text-align: left;
      justify-content: space-between;

      &.type2 {
        width: 520px;
      }

      .title {
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 0.18rem;
        color: #FFFFFF;
        margin-bottom: 30px;
        font-weight: 400;
        cursor: pointer;
      }

      .line {
        display: flex;
        // font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 0.14rem;
        color: #FFFFFF;
        margin-bottom: 0.15rem;
        align-items: center;

        .icon {
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.1rem;
        }
      }

      .lists {

        p {
          cursor: pointer;
          font-size: 0.14rem;
          margin-bottom: 15px;
          font-weight: 400;
          // font-family: Source Han Sans CN, Source Han Sans CN;
          color: #FFFFFF;
        }
      }
    }

    .logos {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.6rem;

      .logo1 {
        width: 0.43rem;
        height: 0.43rem;
      }

      .logo2 {
        width: 1.28rem;
        height: 0.3rem;
      }
    }
  }

  .bottom {
    height: 0.57rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;

    .button{
      cursor: pointer;

      &:hover{
        color: #2d8cf0;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .foot {
    padding: 0 0.3rem;

    .top {
      padding-top: 0.3rem;

      .left {
        .title {
          font-size: 0.32rem;
          margin-bottom: 0.5rem;

        }

        .line {
          font-size: 0.32rem;

          .icon {
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.2rem;
          }
        }

        .erweima {
          width: 1.12rem;
          height: 1.12rem;
        }
      }

      .logos {
        margin-top: 0.2rem;

        // .logo2{
        //   width: 2.11rem;
        //   height: 0.76rem;
        // }
      }
    }

    .bottom {
      height: 1.4rem;
      flex-direction: column;
      align-items: flex-start;
      font-size: 0.16rem;
      line-height: 0.32rem;
      justify-content: center;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/foot.vue